import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { RichTextEditor, styleVariables } from '@lib/common';
import { RequestStatus } from '@module/form';
import styled from '@xstyled/styled-components';
import { Form } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ChildrenContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), styleVariables.margin.large);
export var QuestionEditorComponent = function QuestionEditorComponent(_ref) {
  var form = _ref.form,
      question = _ref.question,
      defaultDescription = _ref.defaultDescription,
      file = _ref.file,
      onShowingUploadQuestionFileModal = _ref.onShowingUploadQuestionFileModal,
      onShowingUploadQuestionAudioFileModal = _ref.onShowingUploadQuestionAudioFileModal,
      onResetAddQuestionFileUseCase = _ref.onResetAddQuestionFileUseCase,
      addQuestionFileStatus = _ref.addQuestionFileStatus,
      children = _ref.children,
      editorLabels = _ref.editorLabels;
  var richTextEditorRef = useRef(null);

  var _useState = useState(question.description || ''),
      content = _useState[0],
      setContent = _useState[1];

  var handleEditorChangeText = useCallback(function (value) {
    form.setFieldValue('description', value);
    setContent(value);
  }, [form]);
  useEffect(function () {
    if (addQuestionFileStatus === RequestStatus.SUCCESS && file && file.url) {
      richTextEditorRef.current.insertImageHandler(file.url);
      onResetAddQuestionFileUseCase();
    }
  }, [addQuestionFileStatus, onResetAddQuestionFileUseCase, file]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children && /*#__PURE__*/_jsx(ChildrenContainer, {
      children: children
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: 'description',
      children: /*#__PURE__*/_jsx(RichTextEditor, {
        ref: richTextEditorRef,
        addImage: onShowingUploadQuestionFileModal,
        placeholder: defaultDescription,
        onChange: handleEditorChangeText,
        content: content,
        editorLabels: editorLabels,
        addAudio: function addAudio() {
          return onShowingUploadQuestionAudioFileModal(question.id.toString());
        }
      })
    })]
  });
};